module.exports = {
      id: "tag-usage",
      viewBox: "0 0 30.383 24.21",
      url: "/" + "sprite-e509a544a5c47560e0a2aa1e13829d5a.svg#tag",
      toString: function () {
        return this.url;
      }
    }